'use client'

import React, { FunctionComponent, useContext } from 'react'
import Modal from '@/app/_components/Modal/Modal'
import ModalContext from '@/app/_providers/ModalProvider/ModalContext'
import TXT from '@/messages'
import StepContext from '@/app/_providers/StepProvider/StepContext'

type Props = {
  onConfirm?: () => void
}

const ExpirationModal: FunctionComponent<Props> = ({ onConfirm }) => {
  const {
    modalState,
    updateModalState,
  } = useContext(ModalContext)
  const { handleRestart } = useContext(StepContext)

  const closeModals = (): void => {
    updateModalState({ open: { expiration: false } })
    const restart = onConfirm ?? handleRestart
    restart()
  }

  return (
    <Modal
      header={TXT.expirationModal.header}
      body={TXT.expirationModal.body}
      confirmButton={TXT.buttons.startOver}
      onConfirm={closeModals}
      onOverlayClick={closeModals}
      onModalClick={closeModals}
      showCancelButton={false}
      visible={modalState.open.expiration}
      setVisible={(isVisible) => updateModalState({ open: { expiration: isVisible } })}
      testId="expiration-modal"
    />
  )
}

export default ExpirationModal
